"use client";

import React from "react";
import Link from "next/link";

const ExtractionsLocation: React.FC = () => {
  return (
    <section className="w-full py-6 sm:py-8 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
        <h2
          className="
            text-2xl sm:text-3xl font-semibold text-gray-800 text-center
            pb-6 after:content-[''] after:block after:w-[200px] after:h-[3px] after:mx-auto after:mt-2
            after:bg-[linear-gradient(to_right,#AE7D2F_0%,#ECD05B_50%,#AE7D2F_100%)]
          "
        >
          Tooth Extractions Near Steinway St. - Serving Astoria and Queens
        </h2>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          Smile4Me Dental Care is located at{" "}
          <Link
            href="/our-office/"
            className="inline-block bg-gradient-to-r from-[#AE7D2F] via-[#ECD05B] to-[#AE7D2F] bg-clip-text text-transparent hover:underline transition-all duration-300 ease-in-out"
          >
            31-57 Steinway St in Astoria, Queens
          </Link>
          , a five-minute walk from the Steinway St station on the R and M
          lines, with multiple bus routes stopping nearby. We serve patients
          throughout the borough, including Long Island City, Jackson Heights,
          Woodside, Sunnyside, and surrounding neighborhoods.
        </p>
      </div>
    </section>
  );
};

export default ExtractionsLocation;
